module.exports = __webpack_public_path__ + "static/media/step-icon-left.710e8e1e.svg";